import {
  loopbackGet, loopbackPut,
} from '..';
import { Certificate } from '../../redux/types';

type CertBundleResponse = {
  bundlePath: string;
};

export const checkCertificateExist = (
  id: number,
): Promise<boolean> => new Promise((resolve, reject) => {
  loopbackGet(`Certificates/checkCertificateExist?certificateId=${id}`).then((res: boolean) => {
    resolve(res);
  }, reject);
});

export const createCertificateFile = (
  id: number,
): Promise<string> => new Promise((resolve, reject) => {
  loopbackGet(`Certificates/createCertificateFile?certificateId=${id}`).then((res: string) => {
    resolve(res);
  }, reject);
});

export const downloadCertificateBundle = (
  trialId: number,
): Promise<CertBundleResponse> => {
  const uri = `/Certificates/downloadBundleForTrial?trialId=${trialId}`;
  return loopbackGet(uri);
};

export const updateCertificate = (cert: Certificate): Promise<Certificate> => loopbackPut(`Certificates/${cert.id}`, cert);
